module.exports = __webpack_public_path__ + "img/paginas-modal.8422e820.svg";